import { getComponentsById } from 'store/quotes/selectors';

import * as types from './types';

const initialState = {
  isOpen: false,
  componentIds: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        componentIds: payload.componentIds,
      };
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
        componentIds: [],
      };
    default:
      return state;
  }
};

const getScope = (state) =>
  state.modules.quotes.quoteItemNav.bulkEditProfitItemsDrawer;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getComponents = (state) =>
  getComponentsById(state, getScope(state).componentIds);

export default reducer;
